// apicore
import { APICore } from '../../helpers/api/apiCore';
import { UOMType as UOMTypeDataType } from 'src/types/unitOfMeasurement';
// constants
import { UOMActionTypes } from './constants';

const api = new APICore();

const INIT_STATE = {
    uomList: [],
    uomDetail: {},
    loading: false,
};

type UOMActionType = {
    type:
        | UOMActionTypes.API_RESPONSE_SUCCESS
        | UOMActionTypes.API_RESPONSE_ERROR
        | UOMActionTypes.ADD_UOM
        | UOMActionTypes.EDIT_UOM
        | UOMActionTypes.GET_UOM
        | UOMActionTypes.GET_UOMS
        | UOMActionTypes.RESET
        | UOMActionTypes.RESET_SUCCESS
        | UOMActionTypes.RESET_ERROR;
    payload: {
        actionType?: string;
        data?: UOMTypeDataType | {};
        error?: string | boolean;
        message?: string;
        code?: number;
        success?: boolean;
    };
};

type State = {
    uomDetail?: UOMTypeDataType | {};
    uomList?: UOMTypeDataType[] | [];
    loading?: boolean;
    value?: boolean;
};

const UOM = (state: State = INIT_STATE, action: UOMActionType): any => {
    switch (action.type) {
        case UOMActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case UOMActionTypes.GET_UOMS: {
                    return {
                        ...state,
                        uomList: action.payload.data,
                        loading: false,
                    };
                }
                case UOMActionTypes.GET_UOM: {
                    return {
                        ...state,
                        uomDetail: action.payload.data,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case UOMActionTypes.ADD_UOM: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case UOMActionTypes.EDIT_UOM: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                default:
                    return { ...state };
            }

        case UOMActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case UOMActionTypes.GET_UOMS: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case UOMActionTypes.GET_UOM: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case UOMActionTypes.ADD_UOM: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case UOMActionTypes.EDIT_UOM: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                default:
                    return { ...state };
            }

        case UOMActionTypes.GET_UOMS:
            return { ...state, loading: true };
        case UOMActionTypes.GET_UOM:
            return { ...state, loading: true };
        case UOMActionTypes.ADD_UOM:
            return { ...state, loading: true };
        case UOMActionTypes.EDIT_UOM:
            return { ...state, loading: true };
        case UOMActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                actionType: 'reset',
            };
        case UOMActionTypes.RESET_SUCCESS:
            return {
                ...state,
                loading: false,
                success: false,
                message: '',
                actionType: 'resetSuccess',
            };
        case UOMActionTypes.RESET_ERROR:
            return {
                ...state,
                loading: false,
                error: false,
                message: '',
                actionType: 'resetError',
            };
        default:
            return { ...state };
    }
};

export default UOM;
